import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Button, Typography } from '@mui/material'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import RestaurantIcon from '@mui/icons-material/Restaurant'

export const EmptyShopsState = () => {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        textAlign: 'center',
        px: 2,
      }}
    >
      <RestaurantIcon
        sx={{
          fontSize: 50,
          color: 'text.secondary',
          mb: 3,
          opacity: 0.5,
        }}
      />

      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          mb: 4,
          maxWidth: 400,
        }}
      >
        お気に入りのお店を追加して、あなただけのお気に入り店舗リストを作成しましょう🥢
      </Typography>
      <Button
        color="primary"
        variant="contained"
        size="large"
        startIcon={<AddCircleIcon />}
        onClick={() => navigate('/create-shop')}
        sx={{
          fontWeight: 'bold',
          px: 4,
          py: 1.5,
        }}
      >
        最初のお店を追加する
      </Button>
    </Box>
  )
}
